import { QueryKeys } from "@coworker/app/src/components/RoomSettings/hooks/queryKeys";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getMessageNotifications,
  setAllMessageNotificationAsRead,
  setMessageNotificationAsRead,
} from "../service/notification.service";
import { updateQueryCache } from "./updateQueryCache";

export const useNotifications = (
  storeId: string | undefined,
  uid: string | undefined
) => {
  return useQuery({
    queryKey: [QueryKeys.MessageNotifications, { id: uid }],
    queryFn: () => getMessageNotifications(storeId || "", uid || ""),
    enabled: !!storeId && !!uid,
    staleTime: 1000 * 60 * 60, // 1 hour stale time
  });
};

export const useSetNotificationAsUnread = (uid: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (notificationId: string) =>
      setMessageNotificationAsRead(notificationId),
    onSuccess: (notification) => {
      if (uid && notification) {
        updateQueryCache(queryClient, uid, notification);
      }
    },
    onError: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.MessageNotifications, { id: uid }],
      });
    },
  });
};

export const useSetAllNotificationsAsUnread = (uid: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (notificationIds: string[]) =>
      setAllMessageNotificationAsRead(notificationIds),
    onSuccess: (batchUpdateResponse) => {
      if (uid && batchUpdateResponse) {
        for (const notification of batchUpdateResponse.updated) {
          updateQueryCache(queryClient, uid, notification);
        }
      }
    },
  });
};
